export default function adresseGeoCoder(adresse) {
  return new Promise((resolve, reject) => {
    new google.maps.Geocoder()
      .geocode({ address: adresse }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(results[0].geometry.location);
        } else {
          reject();
        }
      });
  });
}



// WEBPACK FOOTER //
// ./src/services/general/adresseGeoCoder.js